/**
 * عنوانی که توضیحش را شناور نشان می‌دهد — با نگه داشتنِ ماوس یا با کلیک.
 *
 * چرا نه `Hint` (یعنی `title`ِ مرورگر): `title` با تأخیر باز می‌شود و با
 * کلیک اصلاً باز نمی‌شود، و این صفحه خواسته بود هر دو کار کنند. کارت `fixed`
 * است تا `.scrollx`ِ جدول‌ها آن را نبُرد. کلیک کارت را سنجاق می‌کند و کلیکِ
 * دوباره (یا جای دیگر) برش می‌دارد؛ کلیک به ردیف/سرستون هم می‌رسد، پس مرتب
 * کردن با کلیک همچنان کار می‌کند.
 */
import React, { useEffect, useRef, useState } from 'react';

export function Tip({ text, help }: { text: React.ReactNode; help?: string }) {
  const ref = useRef<HTMLSpanElement>(null);
  const [hover, setHover] = useState(false);
  const [pinned, setPinned] = useState(false);
  const [pos, setPos] = useState<{ top: number; left: number } | null>(null);

  useEffect(() => {
    if (!pinned) return;
    const off = (e: MouseEvent) => {
      if (!ref.current?.contains(e.target as Node)) setPinned(false);
    };
    document.addEventListener('click', off);
    return () => document.removeEventListener('click', off);
  }, [pinned]);

  if (!help) return <>{text}</>;

  const place = () => {
    const r = ref.current?.getBoundingClientRect();
    if (!r) return;
    const w = Math.min(320, window.innerWidth * 0.8);
    const left = Math.max(8, Math.min(r.right - w, window.innerWidth - w - 8));
    setPos({ top: r.bottom + 6, left });
  };

  return (
    <span ref={ref} className="hint"
      onMouseEnter={() => { place(); setHover(true); }}
      onMouseLeave={() => setHover(false)}
      onClick={() => { place(); setPinned(!pinned); }}>
      {text}
      {(hover || pinned) && pos ? (
        <span className="floattip" style={{ top: pos.top, left: pos.left }}>{help}</span>
      ) : null}
    </span>
  );
}
